import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'irar-east-farm-map',
  template: `
  <maphilight
    	id="EastMap"
    	[config]="config">
    	<img src="../images/EastFarm.jpg"
    		class="map"
    		usemap="#EastFarmArea"
    		alt="Beltsville Agricultural Research Center East Farm"
    		height="587"
    		width="760"
    		border="0">
    	<map name="EastFarmArea">
    		<area (click)="selectSite.emit('BARC 14')"
    			alt="BARC 14"
    			shape="rect"
    			coords="515,129,562,143">
    		<area (click)="selectSite.emit('BARC 15')"
    			alt="BARC 15"
    			shape="rect"
    			coords="579,184,624,195">
    		<area (click)="selectSite.emit('BARC 34')"
    			alt="BARC 34"
    			shape="rect"
    			coords="60,280,105,294" >
    		<area (click)="selectSite.emit('BARC 34A')"
    			alt="BARC 34A"
    			shape="rect"
    			coords="62,197,115,211">
    		<area (click)="selectSite.emit('BARC 35')"
    			alt="BARC 35"
    			shape="rect"
    			coords="548,358,594,370">
    		<area (click)="selectSite.emit('BARC 36')"
    			alt="BARC 36"
    			shape="rect"
    			coords="441,271,490,285">
    		<area (click)="selectSite.emit('BARC 37')"
    			alt="BARC 37"
    			shape="rect"
    			coords="430,153,475,166">
    		<area (click)="selectSite.emit('BARC 44')"
    			alt="BARC 44"
    			shape="rect"
    			coords="76,142,121,157">
    		<area (click)="selectSite.emit('ENTECH M26')"
    			alt="ENTECH M26"
    			shape="rect"
    			coords="276,466,343,480">
    		<area (click)="selectSite.emit('ENTECH R15')"
    			alt="ENTECH R15"
    			shape="rect"
    			coords="244,495,310,509">
    		<area (click)="selectSite.emit('ENTECH 20')"
    			alt="ENTECH 20"
    			shape="rect"
    			coords="573,288,633,306">
    		<area (click)="selectSite.emit('EPIC 47')"
    			alt="EPIC 47"
    			shape="rect"
    			coords="567,147,610,161">
        <area (click)="selectSite.emit('Beltsville Bog')"
    			alt="Beltsville Bog"
    			shape="rect"
    			coords="291,118,360,130">
    	</map>
    </maphilight>
  `
})
export class EastFarmMapComponent {
  @Input() config: any;
  @Output() selectSite: EventEmitter<string> = new EventEmitter();
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/components/east-farm-map.ts